import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    h: 2,
    m: 0,
    s: 0
  });
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    let endTime = sessionStorage.getItem('countdown_end');
    if (!endTime) {
      endTime = (Date.now() + 2 * 60 * 60 * 1000).toString();
      sessionStorage.setItem('countdown_end', endTime);
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const distance = parseInt(endTime!) - now;
      if (distance <= 0) {
        clearInterval(interval);
        setIsExpired(true);
      } else {
        setTimeLeft({
          h: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          m: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          s: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className={`fixed bottom-0 left-0 right-0 bg-black/95 backdrop-blur-md border-t border-gold/25 p-[12px_24px] z-[100] transition-transform duration-500 ease-in-out ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-387">
      <div className="container-custom max-w-[900px] flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-388">
        <div className="flex items-center gap-4 w-full sm:w-auto justify-between sm:justify-start" data-id="element-389">
          <div data-id="element-390">
            <span className="text-[12px] text-gray line-through mr-2" data-id="element-391">
              $42.000
            </span>
            <span className="text-[18px] font-bold text-white" data-id="element-392">$17.990</span>
          </div>

          <div className="flex items-center gap-2 bg-gold/10 border border-gold/20 px-3 py-1.5 rounded-[6px]" data-id="element-393">
            <span className="w-2 h-2 rounded-full bg-gold animate-pulse shrink-0" data-id="element-394" />
            <span className="text-[13px] font-mono text-gold font-semibold" data-id="element-395">
              {isExpired ? '¡Oferta por tiempo limitado!' : `${formatTime(timeLeft.h)}:${formatTime(timeLeft.m)}:${formatTime(timeLeft.s)}`}
            </span>
          </div>
        </div>

        <Button href="#oferta" variant="primary" className="w-full sm:w-auto !py-2.5 !px-6 !text-[14px]" fullWidth={false} data-id="element-396">
          Acceder al Protocolo →
        </Button>
      </div>
    </div>;
}